import { embed, youtube } from '../../common/regex';

export function rewrite(arg = '') {
  let result = arg;

  if (youtube.test(result) && embed.test(result) === false) {
    result = result
      .replace(/(.*\/)(.*)/, '$1embed/$2')
      .replace('youtu.be', 'youtube.com')
      .replace('watch?v=', '');
  }

  return result;
}
